import React, { createContext, useContext, useEffect, useState } from 'react';
import { MemoryRouterContext } from './MemoryRouterContext';
import { Signer } from '../services/signer/signer';
import { getSigner } from '../services/signer';

export interface SignerProps {
  signer?: Signer;
}

export const SignerContext = createContext<SignerProps>({} as SignerProps);

type SignerProviderProps = {
  children: JSX.Element;
};

/**
 * Provider that makes available a signer context.
 * The signer is built using the Signer service.
 * The chain parameter is expected as a query parameter.
 *
 * @param props
 * @constructor
 */
export function SignerProvider(props: SignerProviderProps): JSX.Element {
  const { queryParams } = useContext(MemoryRouterContext);
  const [signer, setSigner] = useState<Signer | undefined>(undefined);

  const { children } = props;

  useEffect(() => {
    const { chain, instanceId } = queryParams || {};
    if (!signer) {
      setSigner(getSigner(instanceId as string, chain as 'solana' | 'ethereum' | 'casper'));
    }
  }, [queryParams, signer]);

  return (
    <SignerContext.Provider
      value={{
        signer,
      }}
    >
      {children}
    </SignerContext.Provider>
  );
}

export const useSigner = (): SignerProps => useContext(SignerContext);
